
import React, { useState } from 'react';
import { api } from '../services/api';

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('admin@example.com');
  const [password, setPassword] = useState('password');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      await api.auth.login(email, password);
      onLogin();
    } catch (err) {
      setError('System Access Denied. Verify credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center p-4 relative overflow-hidden font-sans">
      {/* Background Ambience */}
      <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-indigo-600/10 rounded-full blur-[120px] animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-emerald-600/5 rounded-full blur-[100px]"></div>
      
      <div className="bg-white/5 backdrop-blur-3xl w-full max-w-[480px] rounded-[3rem] border border-white/10 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.5)] overflow-hidden animate-in zoom-in-95 duration-700">
        
        <div className="p-12 text-center">
          <div className="w-16 h-16 bg-indigo-600 rounded-[1.5rem] flex items-center justify-center text-white font-black text-3xl shadow-[0_0_40px_rgba(79,70,229,0.4)] mx-auto mb-8 animate-bounce duration-[3s]">
            S
          </div>
          <h1 className="text-3xl font-black text-white tracking-tight">Welcome Back</h1>
          <p className="text-slate-400 text-sm mt-2 font-medium">Sign in to your SubScale account.</p>
        </div>

        <div className="px-12 pb-12">
          {error && (
            <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-5 py-3.5 rounded-2xl text-[11px] font-bold flex items-center gap-3 mb-8 animate-in slide-in-from-top-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] ml-1">Email Address</label>
              <input 
                type="email" 
                required
                className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-2xl outline-none focus:ring-4 focus:ring-indigo-600/10 focus:border-indigo-600/50 font-bold text-sm text-white transition-all placeholder:text-slate-700"
                placeholder="admin@subscale.io"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <label className="text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] ml-1">Password</label>
              </div>
              <input 
                type="password" 
                required
                className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-2xl outline-none focus:ring-4 focus:ring-indigo-600/10 focus:border-indigo-600/50 font-bold text-sm text-white transition-all placeholder:text-slate-700"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button 
              type="submit" 
              disabled={loading}
              className="w-full py-5 bg-indigo-600 text-white rounded-2xl font-black text-xs uppercase tracking-[0.25em] hover:bg-indigo-700 shadow-[0_15px_30px_-5px_rgba(79,70,229,0.3)] transition-all active:scale-[0.98] flex justify-center items-center gap-3"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
          
          <div className="mt-12 text-center">
            <p className="text-[9px] text-slate-600 font-black uppercase tracking-[0.3em]">SubScale Global Access • 256-bit AES</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
